import React, { useEffect, useRef, useState, useMemo } from 'react';
// import { Button, Modal, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import break_box from '../../../../images/product/break_box.png';
import $ from "jquery";
import Select, { components } from "react-select";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import swal from "sweetalert2";

const Delivermanagement = () => {

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const sno = queryParams.get('data');

  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const [datas, setData] = useState([]);

  // packing data
  const fetchData = () => {
    axios.get(`${baseURL}/subscriber-packing-view/${sno}`)
      .then(response => {
        setData(response.data.data);
      })
      .catch(error => {
        console.log('There was an error fetching the data!', error);
      });
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  // delivery vehicles
  const [vehiopt, setvehiopt] = useState([]);
  const [vehiFetch, setVehiFetch] = useState(false);
  useEffect(() => {
    axios.get(`${baseURL}/dropdown/get_vehicles`, { params: { branch_id } })
      .then(response => {
        const formattedsource = response.data.data.map(item => ({
          value: item.sno,
          title: item.vehicle_brand,
          subtitle: item.vehicle_number,
          label: item.vehicle_brand,
          staff_id: item.assigned_staff_id,
          staff_name: item.assigned_staff_name,
          staff_number: item.assigned_staff_number
        }));
        setvehiopt(formattedsource);
        setVehiFetch(true);
      })
      .catch(error => {
        console.log(error);
        setVehiFetch(true);
      });
  }, []);

  // delivery staffs
  const [staffoption, setstaffopt] = useState([]);
  const [staffFetch, setStafFetch] = useState(false);
  useEffect(() => {
    axios.get(`${baseURL}/dropdown/get_staffs`, { params: { branch_id } })
      .then(response => {
        const formattedsource = response.data.data.map(item => ({
          value: item.sno,
          label: item.employee_name,
        }));
        setstaffopt(formattedsource);
        setStafFetch(true);
      })
      .catch(error => {
        setStafFetch(true);
        console.log(error);
      });
  }, []);

  //------------------------------- meals point ----------------------------
  const [agency, setAgency] = useState([]);
  const [freelancer, setfreelancer] = useState([]);
  const [mpfetch, setmpFetch] = useState(false);
  useEffect(() => {
    axios.get(`${baseURL}/dropdown/get_melaspoints`, { params: { branch_id } })
      .then(response => {
        const formattedAgency = response.data.agency.map(item => ({
          value: item.sno,
          label: item.name,
          mob_no: item.mobile_no
        }));
        const formattedfreelance = response.data.freelancer.map(item => ({
          value: item.sno,
          label: item.name,
          mob_no: item.mobile_no
        }));

        setAgency(formattedAgency);
        setfreelancer(formattedfreelance);
        setmpFetch(true);
      })
      .catch(error => {
        console.log(error);
        setmpFetch(true);
      });
  }, []);

  const otherStaff = useMemo(() => [
    {
      label: "Agency",
      options: agency,
    },
    {
      label: "Freelancer",
      options: freelancer,
    }
  ], [agency, freelancer]);


  // const [deliveryData, setDeliveryData] = useState([{
  //   id: Date.now(),
  //   selectedVehicle: null,
  //   isChecked: false,
  //   selectedStaff: null,
  //   cards: [],
  //   rows: [],
  // }]);

  const [deliveryData, setDeliveryData] = useState([]);


  // vehicle onchange
  const handleVehicleChange = async (id, selected) => {
    setDeliveryData(prev =>
      prev.map(config =>
        config.id === id ? { ...config, selectedVehicle: selected } : config
      )
    );

    try {
      const res = await fetch(`${baseURL}/get_vehicle_data/${selected.value}?product_id=${datas.product_id}&&date=${datas.packing_date}`);
      const data = await res.json();

      // Map delivery points to Cards format
      const cardsData = data.delivery_points.map((dp, index) => ({
        id: index + 1, // unique id for UI toggling
        dp: dp.delivery_point_name,
        totalArea: dp.areas.length,
        totalStaff: 0, // update if you have staff count
        pc: dp.total_product_count, // product count placeholder
        delivery_point_sno: dp.delivery_point_sno,
        areas: dp.areas
      }));

      // Flatten areas into rows with initial data
      let rowsData = [];
      cardsData.forEach(card => {
        card.areas.forEach(area => {
          rowsData.push({
            id: `${card.id}-${area.area_sno}`, // unique key
            dp: card.dp,
            delivery_point_sno: card.delivery_point_sno,
            area_sno: area.area_sno,
            area: area.area_name,
            staffType: "", // initial empty, can be "Staff" or "MealsPoint"
            selectedOption: null, // selected staff option
            productCount: area.product_count,
            own_staff: 0,
            out_source: 0,
            staff_status: 0,
          });
        });
      });

      // setCards(cardsData);
      // setRows(rowsData);

      setDeliveryData(prev =>
        prev.map(config =>
          config.id === id
            ? { ...config, cards: cardsData, rows: rowsData }
            : config
        )
      );
    } catch (err) {
      console.error("Error fetching vehicle data:", err);
    }
  };

  const handleRadioChange = (configId, rowId, staffType) => {
    setDeliveryData(prev =>
      prev.map(config => {
        if (config.id !== configId) return config;

        const updatedRows = config.rows.map(row =>
          row.id === rowId ? { ...row, staffType, selectedOption: null } : row
        );

        return { ...config, rows: updatedRows };
      })
    );
  };

  const handleSelectChange = (configId, rowId, option) => {
    setDeliveryData(prev =>
      prev.map(config => {
        if (config.id !== configId) return config;

        const updatedRows = config.rows.map(row =>
          row.id === rowId ? { ...row, selectedOption: option } : row
        );

        return { ...config, rows: updatedRows };
      })
    );
  };

  // swift staff checkbox
  const handleCheckboxChange = (id, checked) => {
    setDeliveryData(prev =>
      prev.map(config =>
        config.id === id ? { ...config, isChecked: checked } : config
      )
    );
  };

  // swift staff change
  const handleStaffChange = (id, selected) => {
    setDeliveryData(prev =>
      prev.map(config =>
        config.id === id ? { ...config, selectedStaff: selected } : config
      )
    );
  };

  // add more button
  const handleAddConfig = () => {
    setDeliveryData([...deliveryData, { id: Date.now(), selectedVehicle: null, isChecked: false, selectedStaff: null, cards: [], rows: [] }]);
  };

  // delete icon
  const handleDeleteConfig = (id) => {
    setDeliveryData(deliveryData.filter(config => config.id !== id));
  };

  // toggle selected card
  const toggleCard = (configId, cardId) => {
    setDeliveryData((prev) =>
      prev.map((cfg) =>
        cfg.id === configId
          ? { ...cfg, activeCardId: cfg.activeCardId === cardId ? null : cardId }
          : cfg
      )
    );
  };

  const onInit = () => { };

  const tableRef = useRef(null);
  useEffect(() => {
    if (tableRef.current) {
      if (!$.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable({
          "responsive": true,
          //   "aaSorting": [],
          "ordering": false,
          "scrollY": 200,
          "paging": false,
          "language": {
            "lengthMenu": "Show _MENU_",
          },
          "dom":
            "<'row'" +
            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
            // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
            ">" +
            "<'table-responsive'tr>" +
            "<'row'" +
            // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
            ">"
        });
      }
    }
  }, []);

  const Group = (props) => (
    <div style={customStyles}>
      <components.Group {...props} />
    </div>
  );

  // mealspoint dropdown
  const customStyles = {
    groupHeading: (provided) => ({
      ...provided,
      fontSize: '14px',  // Increase the font size for group labels
      fontWeight: 'bold',  // Optional: make the label bold
      color: '#333',  // Optional: change the text color
      backgroundColor: "#fff"
    }),
  };

  // format date display
  const formatDate = (date) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = months[d.getMonth()];
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // -------------------------------------------  submit -------------------------
  // generate post payload
  const preparePayload = () => {
    return {
      branch_id,
      user_id,
      sub_delivery_date: datas.packing_date,
      sub_delivery_packing: parseInt(sno, 10),
      sub_delivery_product: datas.product_id,
      sub_delivery_vehicle: deliveryData.map(config => {
        // Use rows and cards from this config only
        const deliveryPoints = (config.cards || []).map((card, idx) => {
          const filteredRows = (config.rows || []).filter(
            row => row.delivery_point_sno === card.delivery_point_sno
          );

          return {
            id: idx + 1,
            delivery_point_sno: card.delivery_point_sno,
            total_areas: filteredRows.length,
            total_staff: filteredRows.reduce((acc, r) => acc + (r.selectedOption ? 1 : 0), 0),
            delivery_boy: "",
            areas: filteredRows.map(row => ({
              area_sno: row.area_sno,
              own_staff: row.staffType === "Staff" && row.selectedOption ? row.selectedOption.value : 0,
              out_source: row.staffType === "MealsPoint" && row.selectedOption ? row.selectedOption.value : 0,
              staff_status: row.staffType === "Staff" ? 0 : 1,
              product_count: row.productCount,
            })),
          };
        });

        return {
          vehicle_id: config.selectedVehicle ? config.selectedVehicle.value : null,
          staff_id: config.isChecked
            ? config.selectedStaff?.value || null
            : config.selectedVehicle?.staff_id || null,
          sub_delivery_points: deliveryPoints,
        };
      }),
    };
  };

  const validateStaffSelection = () => {
    for (const config of deliveryData) {
      for (const row of config.rows) {
        if (!row.selectedOption) {
          return false; // Missing staff
        }
      }
    }
    return true;
  };

  // submit
  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateStaffSelection()) {
      swal.fire({
        icon: "warning",
        title: "Staff Not Allocated",
        text: "All areas must have staff selected before submitting.",
      });
      return;
    }

    let payload = preparePayload();
    console.log(payload);

    if (payload) {
      axios.post(`${baseURL}/sub_delivery`, payload)
        .then(response => {
          navigate('/manage-packing', {
            state: { toastMessage: 'Product Dispatched Successfully!', toastType: 'success' }
          });
        })
        .catch(error => {
          console.log("Error:", error);
          navigate('/manage-packing', {
            state: { toastMessage: 'Product Dispatch Failed', toastType: 'error' }
          });
        });
    }
  };


  useEffect(() => {
    const preloadVehicles = async () => {
      setLoading(true);

      try {

        let prefilled = [];

        for (const vehicle of vehiopt) {
          const res = await fetch(
            `${baseURL}/get_vehicle_data/${vehicle.value}?product_id=${datas.product_id}&&date=${datas.packing_date}`
          );

          const vData = await res.json();
          console.log(vData);
          // Only include if delivery_points present
          if (!vData.delivery_points || vData.delivery_points.length === 0) continue;

          // Convert delivery_points → cards
          const cards = vData.delivery_points.map((dp, index) => ({
            id: index + 1,
            dp: dp.delivery_point_name,
            delivery_point_sno: dp.delivery_point_sno,
            totalArea: dp.areas.length,
            pc: dp.total_product_count,
            areas: dp.areas
          }));

          // Convert areas → rows
          let rows = [];
          cards.forEach(card => {
            card.areas.forEach(area => {
              rows.push({
                id: `${card.id}-${area.area_sno}`,
                dp: card.dp,
                delivery_point_sno: card.delivery_point_sno,
                area_sno: area.area_sno,
                area: area.area_name,
                productCount: area.product_count,
                staffType: area.delivery_type === 1 ? 'MealsPoint' : 'Staff',
                selectedOption: area.delivery_type === 1 ? otherStaff.flatMap(g => g.options).find(opt => opt.value == area.meals_point_id) ?? null : staffoption.find(val => val.value == area.staff_id) ?? null,
                own_staff: area.staff_id ? area.staff_id : 0,
                out_source: area.meals_point_id ? area.meals_point_id : 0,
                staff_status: area.delivery_type === 1 ? 1 : 0,
              });
            });
          });

          prefilled.push({
            id: Date.now() + Math.random(),
            selectedVehicle: vehicle,   // prefill dropdown
            isChecked: false,
            selectedStaff: null,
            cards,
            rows,
            activeCardId: null,
          });
        }

        console.log("prefilled: ", prefilled);
        setDeliveryData(prefilled);
        setLoading(false);
      } catch (err) {
        console.error("Prefetch Error:", err);
        setLoading(false);
      }

    };

    if (vehiFetch && staffFetch && mpfetch) {
      console.log("Yes all 3: ", vehiopt, staffoption, otherStaff);
      preloadVehicles();
    }
  }, [vehiopt, staffoption, otherStaff, vehiFetch, staffFetch, mpfetch]);

  const toTwoDigits = (num) => num.toString().padStart(2, "0");


  return (
    <>
      {/* header */}
      {loading ? (
        <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
          <div className='mb-2'>
            <div className="mb-0 px-0">
              <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
            </div>
            <ol className="breadcrumb fs-7">
              <li className="breadcrumb-item"><Skeleton width={70} /></li>
              <li className="breadcrumb-item"><Skeleton width={20} /></li>
              <li className="breadcrumb-item active"><Skeleton width={100} /></li>
            </ol>
          </div>
          <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
            <Skeleton width={90} height={30} borderRadius={12} />
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
          <div className='mb-0'>
            <div className="mb-0 px-0">
              <h4 className='breadcrumb-header'> Dispatch Product</h4>
            </div>
            <ol className="breadcrumb fs-7">
              <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
              <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
              <li className="breadcrumb-item">Production Management</li>
              <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
              <li className="breadcrumb-item active">Manage Packing</li>
            </ol>
          </div>

          <div className='d-flex flex-column align-items-center justify-content-center gap-1'>
            <label className='fs-5 text-danger font-w600'>
              {datas.packing_date ? formatDate(datas.packing_date) : ''}
            </label>
          </div>
        </div>
      )}

      {/* body */}
      {loading ? (
        <>
          <div className='row mb-2'>
            <div className='col-lg-12'>
              <div className='row mb-4'>
                {/* Header section */}
                <div className="col-lg-4 d-flex flex-row align-items-center justify-content-start gap-2 mb-2">
                  <Skeleton width={90} height={90} borderRadius={12} />
                  <div className='d-flex flex-column align-items-start justify-content-start'>
                    <Skeleton width={90} height={30} borderRadius={12} />
                    <Skeleton width={90} height={30} borderRadius={12} />
                  </div>
                </div>
                <div className='col-lg-4'>
                  <div className='d-flex flex-column align-items-start justify-content-start'>
                    <Skeleton width={90} height={30} borderRadius={12} />
                    <Skeleton width={40} height={40} borderRadius={5} />
                  </div>
                </div>
              </div>

              {Array.from({ length: 3 }).map((_, i) => (
                <div className="mb-3" key={i}>

                  {/* Vehicle + staff row */}
                  <div className="row">

                    {/* Vehicle Dropdown Skeleton */}
                    <div className="col-lg-3 mb-4">
                      <label className="text-black font-w500 fs-6"><Skeleton width={120} /></label>
                      <Skeleton height={38} borderRadius={8} />
                    </div>

                    {/* Vehicle details block */}
                    <div className="col-lg-2 mb-2">
                      <label className="text-black font-w500 fs-6"><Skeleton width={70} /></label>
                      <div className="d-flex flex-column gap-2 mt-2">
                        <Skeleton width={110} height={16} />
                        <Skeleton width={70} height={14} />
                      </div>
                    </div>

                    {/* Staff / checkbox */}
                    <div className="col-lg-3 mb-2">
                      <label className="text-black font-w500 fs-6"><Skeleton width={120} /></label>
                      <Skeleton height={38} borderRadius={8} />
                    </div>

                    {/* delete button */}
                    <div className="col-lg-1 mb-1 px-1 py-1">
                      <Skeleton width={40} height={40} borderRadius={8} />
                    </div>
                  </div>

                  {/* Accordion/Card skeleton */}
                  <div className="scroll-y mh-700px">
                    {[1, 2].map((cardIndex) => (
                      <div key={cardIndex} className="col-lg-12 mb-2">
                        <div className="card mb-3" style={{ borderRadius: "10px", overflow: "hidden" }}>

                          {/* Card header */}
                          <div className="row bg-success-light p-3">
                            <div className="col-lg-3 mt-4">
                              <Skeleton width={120} height={20} />
                            </div>

                            <div className="col-lg-3 d-flex flex-column align-items-center">
                              <Skeleton width={70} height={14} />
                              <Skeleton width={50} height={28} borderRadius={6} className="mt-2" />
                            </div>

                            <div className="col-lg-3 d-flex flex-column align-items-center">
                              <Skeleton width={70} height={14} />
                              <Skeleton width={50} height={28} borderRadius={6} className="mt-2" />
                            </div>

                            <div className="col-lg-3 mt-4 d-flex justify-content-center">
                              <Skeleton width={30} height={30} borderRadius={6} />
                            </div>
                          </div>

                          {/* Card body rows */}
                          <div className="card-body py-3 border-top">
                            {[1, 2, 3].map((rowIndex) => (
                              <div key={rowIndex} className="row mb-3">

                                {/* Area */}
                                <div className="col-lg-4">
                                  <Skeleton width={140} height={16} />
                                </div>

                                {/* Staff radio + select */}
                                <div className="col-lg-4 d-flex flex-column">
                                  <Skeleton width={100} height={16} />
                                  <Skeleton height={36} borderRadius={6} className="mt-2" />
                                </div>

                                {/* MealsPoint radio + select */}
                                <div className="col-lg-4 d-flex flex-column">
                                  <Skeleton width={120} height={16} />
                                  <Skeleton height={36} borderRadius={6} className="mt-2" />
                                </div>

                              </div>
                            ))}
                          </div>

                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <div className='row mb-2'>
          <div className='col-lg-12'>

            <div className='row mb-4'>
              {/* Header section */}
              <div className="col-lg-4 d-flex flex-row align-items-center justify-content-start gap-2 mb-2">
                <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                  <div data-src={datas.product_image || break_box} className='border rounded px-1 py-0'>
                    <img src={datas.product_image || break_box} alt={datas.product_name} className='cursor-pointer w-60px h-60px' />
                  </div>
                </LightGallery>
                <div className='d-flex flex-column align-items-start justify-content-start'>
                  <label className='text-primary font-w600 fs-5'>{datas.product_name}</label>
                  <label className="fs-7 text-dark">{datas.product_category_name}</label>
                </div>
              </div>
              <div className='col-lg-4'>
                <div className='d-flex flex-column align-items-start justify-content-start'>
                  <label className='text-black font-w500 fs-5'>Total Products</label>
                  <label className="fs-5 text-danger font-w500 border border-danger py-1 px-2 rounded">{datas.subscriber_count ? toTwoDigits(datas.subscriber_count) : ''}</label>
                </div>
              </div>
            </div>

            <div className='row mb-2'>
              <div className="col-lg-12">
                <div className="mb-0">

                  {!loading && deliveryData.length === 0 && (
                    <div className="text-center text-danger fs-5 p-3">
                      No delivery assignments available.
                    </div>
                  )}

                  {deliveryData.map((config) => (
                    <div className='mb-3' key={config.id} data-repeater-item>

                      <div className="row">

                        {/* Prefilled Vehicle Dropdown */}
                        <div className="col-lg-3 mb-4 d-none">
                          <label className="text-black font-w500 fs-6">Assign Vehicle</label>
                          <Select
                            options={vehiopt}
                            value={config.selectedVehicle}
                            isDisabled     // ⛔ cannot change vehicle (optional)
                          />
                        </div>

                        {/* vehicle details */}
                        <div className="col-lg-2 mb-2">
                          <label className="text-black font-w500 fs-6">Vehicle</label>
                          <div className="d-flex flex-column align-items-start gap-2 mb-2">
                            <label className="text-danger font-w600 fs-6">
                              {config.selectedVehicle?.label}
                            </label>
                            <label className="text-dark font-w600 fs-6">
                              ({config.selectedVehicle?.subtitle})
                            </label>
                          </div>
                        </div>

                        {/* staff details */}
                        <div className="col-lg-2 mb-2">
                          <label className="text-black font-w500 fs-6">Staff</label>
                          <div className="d-flex flex-column align-items-start gap-2 mb-2">
                            <label className="text-danger font-w600 fs-6">
                              {config.selectedVehicle?.staff_name}
                            </label>
                            <label className="text-dark font-w600 fs-6">
                              {config.selectedVehicle?.staff_number}
                            </label>
                          </div>
                        </div>

                        {/* Swift Staff checkbox kept same */}
                        <div className="col-lg-3 mb-2">
                          <label className="text-black font-w500 fs-6">
                            <input type="checkbox"
                              onChange={(e) => handleCheckboxChange(config.id, e.target.checked)}
                              className="form-check-input me-2"
                            />
                            Swift Staff
                          </label>

                          {config.isChecked && (
                            <Select
                              placeholder="Select Staff"
                              onChange={(selected) => handleStaffChange(config.id, selected)}
                              options={staffoption}
                              value={config.selectedStaff}
                            />
                          )}
                        </div>

                        {/* delete block unchanged */}
                        <div className="col-lg-1 mb-1 px-1 py-1 d-none">
                          {deliveryData.length > 1 && (
                            <button className="btn btn-danger mt-4 px-2 py-2"
                              onClick={() => handleDeleteConfig(config.id)}>
                              <i className="fa-solid fa-trash-can fs-6 text-white"></i>
                            </button>
                          )}
                        </div>
                      </div>

                      {/* Cards + Rows unchanged */}
                      <div className='scroll-y mh-700px'>
                        {config.cards.map(card => {

                          const cardRows = config.rows.filter(row => row.dp === card.dp);

                          // Check whether all areas have a staff selected
                          const isAllStaffAssigned = cardRows.every(row => row.selectedOption !== null);

                          // You can use this boolean later outside too if needed
                          // Example: store it on card
                          card.isAllStaffAssigned = isAllStaffAssigned;

                          return (
                            <div key={card.id} className="col-lg-12 mb-2">
                              <div className="card mb-3" style={{ borderRadius: "10px", overflow: "hidden" }}>

                                <div className="row bg-success-light p-3" style={{ cursor: "pointer" }} onClick={() => toggleCard(config.id, card.id)}>
                                  <div className="col-lg-3 mt-4">
                                    <label className="text-black font-w500 fs-5">{card.dp}</label>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                      <label className="fw-semibold text-black fs-5">Total Area</label>
                                      <span className="bg-primary text-white rounded fs-5 py-2 px-2">{card.totalArea ? toTwoDigits(card.totalArea) : ''}</span>
                                    </div>
                                  </div>
                                  <div className="col-lg-3">
                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                      <label className="fw-semibold text-black fs-5">Total Count</label>
                                      <span className="bg-primary text-white rounded fs-5 py-2 px-2">{card.pc ? toTwoDigits(card.pc) : ''}</span>
                                    </div>
                                  </div>
                                  <div className="col-lg-3 mt-4">
                                    <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                                      {!isAllStaffAssigned && (
                                        <label className="d-block text-danger font-w500 fs-6 border border-danger py-1 px-3 rounded">
                                          Staff Not Allocated
                                        </label>
                                      )}
                                      <i className={`fa-solid fa-chevron-${config.activeCardId === card.id ? "up" : "down"} text-primary bg-gray-400 py-2 px-2 rounded`} style={{ fontSize: "1.25rem" }}></i>
                                    </div>
                                  </div>
                                </div>

                                {config.activeCardId === card.id && (
                                  <div className="card-body py-3 border-top">
                                    <div className="table-container">
                                      <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                          <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                            <th className="min-w-100px">Area</th>
                                            <th className="min-w-200px text-center">Staff Type</th>
                                            <th className="min-w-100px text-center">Product Count</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {config.rows.filter(row => row.dp === card.dp).map(row => (
                                            <tr key={row.id}>
                                              <td className='align-content-center'>
                                                <label className="text-black font-w500 fs-6">{row.area}</label>
                                              </td>
                                              <td>
                                                <div className="row">
                                                  <div className="col-lg-6 d-flex flex-column mb-3">
                                                    <div className="form-check-inline">
                                                      <input className="form-check-input" type="radio"
                                                        name={`staffMeals-${row.id}`}
                                                        value="Staff"
                                                        checked={row.staffType === "Staff"}
                                                        onChange={() => handleRadioChange(config.id, row.id, "Staff")}
                                                      />
                                                      <label className="text-black font-w500 fs-6">Staff</label>
                                                    </div>
                                                    {row.staffType === "Staff" && (
                                                      <Select
                                                        value={row.selectedOption}
                                                        onChange={(option) => handleSelectChange(config.id, row.id, option)}
                                                        options={staffoption}
                                                        placeholder="Select Staff"
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                      />
                                                    )}
                                                  </div>
                                                  <div className="col-lg-6 d-flex flex-column mb-3">
                                                    <div className="form-check-inline">
                                                      <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name={`staffMeals-${row.id}`}
                                                        value="MealsPoint"
                                                        checked={row.staffType === "MealsPoint"}
                                                        onChange={() => handleRadioChange(config.id, row.id, "MealsPoint")}
                                                      />
                                                      <label className="text-black font-w500 fs-6">Meals Point</label>
                                                    </div>
                                                    {row.staffType === "MealsPoint" && (
                                                      <Select
                                                        value={row.selectedOption}
                                                        onChange={(option) => handleSelectChange(config.id, row.id, option)}
                                                        components={{ Group }}
                                                        styles={{
                                                          ...customStyles,
                                                          menuPortal: base => ({ ...base, zIndex: 9999 })
                                                        }}
                                                        options={otherStaff}
                                                        placeholder="Select Meals Point"
                                                        menuPortalTarget={document.body}
                                                      />
                                                    )}
                                                  </div>
                                                </div>
                                              </td>
                                              <td className="text-center align-content-center">
                                                <label className="fs-6 text-danger font-w500 border border-danger py-1 px-2 rounded"> {row.productCount ? toTwoDigits(row.productCount) : ''} </label>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )
                        })}
                      </div>

                    </div>
                  ))}

                </div>
              </div>
            </div>

            <div className="mb-1 mt-1 d-none">
              <button className="btn btn-sm btn-primary" onClick={handleAddConfig}>
                <i className="fa-solid fa-plus fs-6"></i>
                <span className='ms-2 fs-7'>Add More</span>
              </button>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
              <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit} >Dispatch Product <i className="fas fa-angle-double-right ms-2"></i></Link>
            </div>

          </div>
        </div>
      )}
    </>
  );
}

export default Delivermanagement;